import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { List, ListParams } from 'wflow-cdk';
import { FilterCondition } from 'wflow-variables';
import {
  PeppolAttachment,
  PeppolMessageDetail,
} from '../interfaces/peppol-detail.interface';
import {
  PeppolMessageActionApiPath,
  PeppolRejectRequest,
} from '../interfaces/peppol-item.dto';
import { PeppolItem } from '../interfaces/peppol-item.interface';

export const PEPPOL_MESSAGES_API = new InjectionToken<PeppolMessagesApi>(
  'PEPPOL_MESSAGES_API',
);

export interface PeppolMessagesListParams extends Omit<ListParams, 'query'> {
  filters?: FilterCondition[];
}

export interface PeppolMessagesApi {
  getItems(params?: PeppolMessagesListParams): Observable<List<PeppolItem>>;

  sendItemAction(
    item: PeppolItem,
    apiPath: PeppolMessageActionApiPath,
  ): Observable<void>;

  rejectItem(id: string, request: PeppolRejectRequest): Observable<void>;

  getDetail(messageId: string): Observable<PeppolMessageDetail>;

  getAttachmentContent(
    messageId: string,
    name: string,
  ): Observable<PeppolAttachment>;

  createDocumentFromItem(id: string, typeId: string): Observable<void>;
}
